<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
import navBar from "./store/navBar";

export default {
  name: 'App',
  mounted() {
    window.addEventListener('unload',this.saveTabsList)
  },
  methods:{
    saveTabsList(){
      // window.sessionStorage.clear();
      // console.log('刷新页面了',this.$store.state.tabsValue,JSON.stringify(this.$store.state.tabsValue))
      // console.log(this.$store.state.loginUser);
      window.sessionStorage.setItem("tabsValue",JSON.stringify(this.$store.state.tabsValue));
      window.sessionStorage.setItem("loginUser",JSON.stringify(this.$store.state.loginUser.loginUser));
      window.sessionStorage.setItem("navBar",JSON.stringify(this.$store.state.navBar.nav));
    }
  },
  created() {
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function('event.returnValue=false')
      // 禁用选择
      document.onselectstart = new Function('event.returnValue=false')
      //禁止f12
      // document.onkeydown = new Function('event.returnValue=false')
    })

    // 上面的禁止f12那段代码没有生效，但是加了下面这段就能生效。
    document.onkeydown = function (e) {
      if (e && e.keyCode === 123) {
        e.returnValue = false
        // e.keyCode = 0   //去掉也可以的，倘若要写，则需要setter 以及 getter配合使用，不配合，会报错
        return false
      }
    }
  }
}
</script>

<style>
  html,body,page{
    height: 100%;
  }
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  margin: 0;
  padding: 0;
  height: 100%;
}
  /*dialog  滚动条*/
  .abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
  }
  .abow_dialog .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

  }
  .abow_dialog .el-dialog .el-dialog__body {
    position: absolute;
    left: 0;
    top: 54px;
    bottom: 0;
    right: 0;
    padding: 0;
    z-index: 1;
    overflow: hidden;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue